import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["button"]

    connect() {
        this.clientField = this.element.querySelector('[data-autocomplete-field-key-value="client_id"]')
        this.clientChangedHandler = this.clientChanged.bind(this)
        this.clientField?.addEventListener("autocomplete:changed", this.clientChangedHandler)
        this.updateButton(this.clientField?.querySelector('[data-autocomplete-target="hidden"]')?.value)
    }

    disconnect() {
        this.clientField?.removeEventListener("autocomplete:changed", this.clientChangedHandler)
    }

    clientChanged(event) {
        this.updateButton(event.detail?.value)
    }

    updateButton(clientId) {
        if (!this.hasButtonTarget) return

        const button = this.buttonTarget
        const url = new URL(button.dataset.baseUrl, window.location.origin)
        const hasClient = Boolean(clientId)

        if (hasClient) url.searchParams.set("client_id", clientId)

        button.disabled = !hasClient
        button.dataset.url = `${url.pathname}${url.search}`
    }
}
